import { HttpParams } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';
import { ExaminationSlideText, ExaminationSlideTextList } from '../../model/examinationSlides.model';

export enum SlideTextTypes {
    GET_SlideText = '[SlideText] Get SlideText',
    SET_SlideText = '[SlideText] Set SlideText',
    GET_SlideText_URL = '[SlideText] Get SlideText FROM URL',
    GET_SlideText_SUCCESS = '[SlideText] Get SlideText Success',
    GET_SlideText_FAILURE = '[SlideText] Get SlideText Failure',
}

export const GetSlideText = createAction(
    SlideTextTypes.GET_SlideText,
    props<{ params: HttpParams }>()
)

export const GetSlideTextfromurl = createAction(
    SlideTextTypes.GET_SlideText_URL,
    props<{ url: string }>()
)

export const GetSlideTextSuccess = createAction(
    SlideTextTypes.GET_SlideText_SUCCESS,
    props<{ payload: ExaminationSlideTextList }>()
)

export const GetSlideTextFailure = createAction(
    SlideTextTypes.GET_SlideText_FAILURE,
)

export const SetSlideText = createAction(
    SlideTextTypes.SET_SlideText,
    props<{ slideText: ExaminationSlideText }>()
)